import cn from 'classnames';
import { FC, memo, useCallback } from 'react';

import { MedicalImageInterface } from '@/shared/config';

import { MedicalImage } from '@/features/medicalImage';

import styles from './UploadedSlicesList.module.scss';

type UploadedSlicesListProps = {
  canUserDeleteSlices: boolean;
  medicalImages: MedicalImageInterface[];
  selectedMedicalImages: MedicalImageInterface[];
  className?: string;
  toggleSelected: (medicalImage: MedicalImageInterface) => void;
};

export const UploadedSlicesList: FC<UploadedSlicesListProps> = memo((props) => {
  const {
    className,
    selectedMedicalImages,
    medicalImages = [],
    canUserDeleteSlices,
    toggleSelected,
  } = props;

  const checkIsTheMedicalImageSelected = useCallback(
    (src: string) =>
      selectedMedicalImages?.some((medicalImage) => medicalImage.src === src) ??
      false,
    [selectedMedicalImages],
  );

  return (
    <div
      className={cn(styles.container, className)}
      data-component="uploaded-slices-list"
    >
      {medicalImages.map((medicalImage) => (
        <div key={medicalImage.src} className={styles.medicalImageWrapper}>
          <MedicalImage
            draggable
            key={medicalImage.src}
            medicalImage={medicalImage}
            toggleSelected={toggleSelected}
            order={medicalImage.order}
            canUserDeleteSlices={canUserDeleteSlices}
            isImgSelected={checkIsTheMedicalImageSelected(medicalImage.src)}
          />
        </div>
      ))}
    </div>
  );
});
